import { monthNamesFull, monthNamesShort } from "./constants";

export function aggregateGrowthData(subscribersGrowth) {
  const { subscribed, trial } = subscribersGrowth;

  const currentMonthIndex = new Date().getMonth();

  const slicedMonthsToCurrentMonths = monthNamesShort.slice(
    0,
    currentMonthIndex + 1
  );

  const finalData = slicedMonthsToCurrentMonths.map((month, index) => {
    return {
      name: month,
      golf: {
        subscribed: subscribed[monthNamesFull[index]],
        trial: trial[monthNamesFull[index]],
        combined:
          subscribed[monthNamesFull[index]] + trial[monthNamesFull[index]],
      },
    };
  });

  return finalData;
}

export const customTooltip = (styles) => {
  // closure / currying concept here
  return ({ active, payload }) => {
    const activeSport = payload[0]?.dataKey?.split(".")[0];

    if (active && payload && payload.length) {
      const sportObj = payload[0].payload[activeSport];
      const { trial, subscribed } = sportObj;
      let fill = "#43B582";
      let gradientFill = "";
      if (activeSport === "golf") {
        fill = "#B1E3FF";
        gradientFill = "linear-gradient(180deg, #B1E3FF 0%, #6A8899 100%)";
      } else if (activeSport === "baseball") {
        fill = "#F4BD00";
        gradientFill = "linear-gradient(180deg, #FBB900 0%, #956E00 100%)";
      } else {
        fill = "#43B582";
        gradientFill = "linear-gradient(360deg, #396451 0%, #73CAA4 100%)";
      }

      const color = fill; // Get the corresponding color

      const tooltipLabels = [
        {
          title: "Trial",
          value: trial,
          color: fill,
        },
        {
          title: "Subscribed",
          value: subscribed,
          color: gradientFill,
        },
      ];

      return (
        <div className={styles.customTooltip}>
          <div className={styles.rows}>
            {tooltipLabels?.map((item) => (
              <div>
                <span
                  className={styles.circle}
                  style={{
                    background: item.color,
                  }}
                />
                <span style={{ color: "black", fontWeight: "normal" }}>
                  {item.title}:{" "}
                </span>
                {item.value}
              </div>
            ))}
          </div>
        </div>
      );
    }
    return null;
  };
};
